// extracted by mini-css-extract-plugin
export var orderDetails = "_up-2";
export var orderImage = "_up-1";
export var orderMeta = "_up-3";
export var orderSummary = "_up-0";
export var rightArrow = "_up-4";